import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { NbDialogService } from '@nebular/theme';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { SupportService } from 'src/app/services/support.service';

@Component({
  selector: 'app-kb-article',
  templateUrl: './kb-article.component.html',
  styleUrls: ['./kb-article.component.scss']
})
export class KbArticleComponent implements OnInit {
  article: any = null;
  safeContent: SafeHtml = '';
  role: string | null = null;
  loading = false;
  articleId = '';

  constructor(
    private supportService: SupportService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private dialogService: NbDialogService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.role = localStorage.getItem('role');
    this.articleId = this.route.snapshot.paramMap.get('id') || '';
    if (this.articleId) {
      this.loadArticle();
    }
  }

  loadArticle(): void {
    this.loading = true;
    this.spinner.show();
    this.supportService.getArticle(this.articleId).subscribe({
      next: (res: any) => {
        this.article = res.response?.data?.article || res.response?.data || null;
        this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.article?.content || '');
        this.loading = false;
        this.spinner.hide();
      },
      error: (err: any) => {
        this.loading = false;
        this.spinner.hide();
        this.toastr.error(err.error?.response?.message || 'Failed to load article');
      }
    });
  }

  onEdit(): void {
    this.router.navigate(['/support/articles', this.article._id, 'edit']);
  }

  onDelete(): void {
    Swal.fire({
      title: 'Delete Article?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it'
    }).then(result => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.supportService.deleteArticle(this.article._id).subscribe({
          next: () => {
            this.spinner.hide();
            this.toastr.success('Article deleted successfully');
            this.router.navigate(['/support']);
          },
          error: (err: any) => {
            this.spinner.hide();
            this.toastr.error(err.error?.response?.message || 'Failed to delete article');
          }
        });
      }
    });
  }

  formatDate(date: string): string {
    if (!date) { return ''; }
    return new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric'
    });
  }

  goBack(): void {
    this.router.navigate(['/support']);
  }
}
